import { Box } from "@amzn/awsui-components-console";
import React from "react";
import { PAGE_TITLES, ROUTES } from "src/app/constants";
import { useLocation } from "react-router";
import NavigationBarActions from "./NavigationBarActions";
import ClaimsSearchBar from "../claimsSearchBar/ClaimsSearchBar";
import { useAppSelector, useAppDispatch } from "src/redux/hooks";
import { RootState } from "src/redux/store";
import { setValueInAppState } from "src/app/appSlice";
import { WC_LINE_OF_BUSINESS_CONFIG } from "../workersCompensationClaimsHistory/constants";

const ROUTE_TO_TITLE_MAP: { [key: string]: string } = {
  [ROUTES.WC_CLAIM_INTAKE_FORM]: PAGE_TITLES.CLAIM_INTAKE_FORM,
  [ROUTES.MEDICAL_PANEL_DATA]: PAGE_TITLES.MEDICAL_PANEL_DATA,
  [ROUTES.SITE_CONFIGURATION]: PAGE_TITLES.SITE_CONFIGURATION,
  [ROUTES.CLAIMS_HISTORY]: PAGE_TITLES.CLAIMS_HISTORY,
  [ROUTES.WORKERS_COMPENSATION_DOCUMENTS]:
    PAGE_TITLES.WORKERS_COMPENSATION_DOCUMENTS,
  [ROUTES.DOCUMENTS_MANAGEMENT]: PAGE_TITLES.DOCUMENTS_MANAGEMENT,
  [ROUTES.CARGO_CLAIM_INTAKE_FORM]: PAGE_TITLES.CARGO_CLAIM_INTAKE_FORM,
  [ROUTES.LANDING_PAGE]: PAGE_TITLES.LANDING_PAGE,
};
const TopNavigationBar = () => {
  const { showSmallScreenSearchBar } = useAppSelector(
    (state: RootState) => state.app
  );
  const dispatch = useAppDispatch();

  const location = useLocation();
  const title =
    ROUTE_TO_TITLE_MAP[location.pathname || ""] ||
    PAGE_TITLES.CLAIM_INTAKE_FORM;
  const isClaimIntakeFormPage =
    location.pathname === ROUTES.WC_CLAIM_INTAKE_FORM;

  const handleNavigate = (route: string) => {
    window.open(route, "_blank", "noreferrer");
  };

  const handleToggleSmallSearchBar = (value: boolean) => {
    dispatch(setValueInAppState({ key: "showSmallScreenSearchBar", value }));
  };

  return (
    <React.Fragment>
      <header className="app-header" id="app-header">
        <div className="title-and-search-bar">
          {showSmallScreenSearchBar ? null : (
            <div className="page-title">
              <Box padding={{ top: "xxs", left: "l" }}>
                <span className="header-text">{title}</span>
              </Box>
            </div>
          )}
          {isClaimIntakeFormPage ? (
            <ClaimsSearchBar
              topNavigation={true}
              lineOfBusinessConfig={WC_LINE_OF_BUSINESS_CONFIG}
              onNavigate={handleNavigate}
              showSmallScreenSearchBar={showSmallScreenSearchBar}
              onToggleSmallSearchBar={handleToggleSmallSearchBar}
            />
          ) : null}
        </div>
        {showSmallScreenSearchBar ? null : <NavigationBarActions />}
      </header>
    </React.Fragment>
  );
};
export default TopNavigationBar;
